const PATHS = {
  ROOT: '/',
  SIGN_IN: '/sign-in',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  INVITE_ACCEPT: '/invite/accept',
  HOME: '/home',
  DOCUMENTS: '/home/documents',
  DO_VOICE: '/home/voice',
  BUILD: '/home/build',
  SETTINGS: '/settings',
  ABOUT: '/about',
}

/** React Router pattern for `useMatch` / `<Route path={…} />` */
export const HOME_THREAD_ROUTE_PATTERN = '/home/thread/:threadId'

/** Deep link for a home chat thread (SaaS: shareable, refresh-safe). */
export function buildHomeThreadPath(threadId) {
  return `/home/thread/${encodeURIComponent(threadId)}`
}

/** @param {string} sectionId */
export function buildSettingsSectionPath(sectionId) {
  return `${PATHS.SETTINGS}/${encodeURIComponent(sectionId)}`
}

export default PATHS
